<h6 class="content-block">Report Library</h6>
<div class="ax-panel">
  <app-grid name="Report Library">
  </app-grid>
</div>


